import React from "react";
import { Grid, Typography } from "@material-ui/core";
import * as Yup from "yup";
import { TextField, Button } from "@material-ui/core";
import { Label } from "../../../../src/components/formInputs";
import { GenericDialogProps } from "../../dialog";
import { Formik, useFormikContext } from "formik";
import { REQUIRED_FIELD } from "../../../constants";
import { ErrorCommon, TextFieldCommon } from "../../formikFormInputs";
import GenericDialog from "../../dialog/GenericDialog";


export default function PaymentMethodRejectionPopup(props) {
    const { setOpenPopup, openPopup, formValues, setPaymentMethodReject, setIsRejected, setSubmitting } = props;

    const initialValues = {
        rejectionMessage: "",
        internalNote: "",
    };

    const handleClose = () => {
        setOpenPopup(false);
    };
    const validationSchema = Yup.object({
        rejectionMessage: Yup.string().required(`Rejection message is ${REQUIRED_FIELD}`),
        internalNote: Yup.string().required(`Internal note is ${REQUIRED_FIELD}`),
    });

    const handleSubmit = async (values) => {
        setSubmitting(true);
        setIsRejected(true);
        Object.assign(formValues, values);
    }


    const commentDialogProps: GenericDialogProps = {
        "aria-labelledby": "upload_proposal-pop-up-form-dialog-title",
        fullWidth: true,
        maxWidth: "md",
        content: (
            <>
                <Typography variant="body1" className="mb15 floatLeft w100"> The client will receive an email and
                    action item to correct the requested changes.</Typography>
                <Formik
                    initialValues={initialValues}
                    enableReinitialize={true}
                    validationSchema={validationSchema}
                    validateOnChange={true}
                    onSubmit={handleSubmit}
                >
                    {(formikProps) => (
                        <FormContent
                            setIsRejected={setIsRejected}
                            setPaymentMethodReject={setPaymentMethodReject}
                            setOpenPopup={setOpenPopup}
                            {...formikProps} />
                    )}
                </Formik>
            </>
        ),
        dividers: true,
        onClose: handleClose,
        open: openPopup,
        title: "Bank Details",
    };
    return <GenericDialog {...commentDialogProps} />
}

function FormContent(props: any) {
    const { setOpenPopup, setPaymentMethodReject, setIsRejected } = props;
    const {
        values,
        errors,
        touched,
        isSubmitting,
        dirty,
        handleChange,
        handleBlur,
    } = useFormikContext<any>();
    const fieldObj: any = [
        {
            id: "rejectionMessage",
            name: "rejectionMessage",
            label: <Label label={"Rejection Message to Client"} required={true} />,
            isRequired: true,
            component: TextField,
            variant: "outlined",
            multiline: true,
            rows: 4,
        },
        {
            id: "internalNote",
            name: "internalNote",
            label: <Label label={"Internal NIW Note"} required={true} />,
            isRequired: true,
            component: TextField,
            variant: "outlined",
            multiline: true,
            rows: 2,
        },
    ];
    return (
        <form onSubmit={props.handleSubmit}>
            <Grid container spacing={2}>
                {fieldObj.map((field, index) => {
                    return (
                        <Grid item xs={12} key={index}>
                            <TextFieldCommon
                                {...field}
                                values={values}
                                onChange={handleChange}
                                onBlur={handleBlur}
                            />
                            <ErrorCommon errors={errors}
                                name={field.name}
                                touched={touched} />
                        </Grid>
                    );
                })
                }
                <Grid item xs={12}>
                    <Button
                        size="small"
                        type="submit"
                        color="primary"
                        className="floatRight mr10"
                        variant="contained"
                        disabled={(Object.keys(errors).length !== 0) || !dirty || isSubmitting}
                    >
                        Submit
                    </Button>
                    <Button onClick={() => {
                        setOpenPopup(false)
                        setPaymentMethodReject(false);
                        setIsRejected(false);
                    }}
                        size="small"
                        color="default"
                        className="floatRight mr10"
                        variant="contained"
                        disabled={isSubmitting}>
                        Cancel
                    </Button>
                </Grid>
            </Grid>
        </form>
    );
}